<template>
  <div>
    <h5 class="text-center">What product did you purchase?</h5>
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            Brand
          </label>
          <input class="form-control"
                 type="text"
                 name="brand"
                 v-validate="modelValidations.brand"
                 v-model="model.brand"
                 placeholder="ex: Nike">
          <small class="text-danger" v-show="brand.invalid">
            {{ getError('brand') }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label">
            Product
          </label>
          <input class="form-control"
                 type="text"
                 name="product"
                 v-validate="modelValidations.product"
                 v-model="model.product"
                 placeholder="ex: Air Presto">
          <small class="text-danger" v-show="product.invalid">
            {{ getError('product') }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'

  export default {
    computed: {
      ...mapFields(['brand', 'product'])
    },
    data () {
      return {
        model: {
          brand: '',
          product: ''
        },
        brandSelected: true,
        searchIndex: 0,
        products: [],
        brandName: '',
        brandObjects: [],
        modelValidations: {
          brand: {
            required: true
          },
          product: {
            required: true
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FraudReport/Wizard/FirstStep.vue